module.exports = __webpack_public_path__ + "img/noPower.8f3ff6ca.png";